// extracted by mini-css-extract-plugin
module.exports = {"meals":"MAvailable_meals__27EeV","meals-appear":"MAvailable_meals-appear__21Z3I","loading":"MAvailable_loading__2i6yD"};